import { render, staticRenderFns } from "./DropdownSubmenu.vue?vue&type=template&id=4e125a04"
import script from "./DropdownSubmenu.vue?vue&type=script&lang=js"
export * from "./DropdownSubmenu.vue?vue&type=script&lang=js"
import style0 from "./DropdownSubmenu.vue?vue&type=style&index=0&id=4e125a04&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports